import { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import { HiOutlineUser } from "react-icons/hi2";

import SettingsCard from "./SettingsCard";

import { updateProfile } from "../../../../redux/features/settings/settingsSlice";

import "./SettingsForms.css";

export default function ProfileSettingsCard({ user }) {
  const dispatch = useDispatch();

  const { isSavingProfile } = useSelector((state) => state.settings);

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
  });

  useEffect(() => {
    setFormData({
      first_name: user?.first_name || "",
      last_name: user?.last_name || "",
    });
  }, [user]);

  const handleChange = (event) => {
    const { name, value } = event.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    await dispatch(
      updateProfile({
        first_name: formData.first_name.trim(),
        last_name: formData.last_name.trim(),
      }),
    ).unwrap();
  };

  return (
    <SettingsCard
      icon={<HiOutlineUser />}
      title="Profiel"
      description="Wijzig je basisgegevens."
    >
      <form className="settings-form" onSubmit={handleSubmit}>
        <div className="settings-form__grid">
          <div className="settings-form__group">
            <label>Voornaam</label>
            <input
              name="first_name"
              value={formData.first_name}
              onChange={handleChange}
              disabled={isSavingProfile}
            />
          </div>

          <div className="settings-form__group">
            <label>Achternaam</label>
            <input
              name="last_name"
              value={formData.last_name}
              onChange={handleChange}
              disabled={isSavingProfile}
            />
          </div>

          <div className="settings-form__group settings-form__group--full">
            <label>E-mail</label>
            <input value={user.email || ""} disabled />
          </div>
        </div>

        <button className="settings-form__submit" disabled={isSavingProfile}>
          {isSavingProfile ? "Opslaan..." : "Profiel opslaan"}
        </button>
      </form>
    </SettingsCard>
  );
}
